import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fw-b purple-purple-color" }

import { BUTTON_FILL, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonCol, IonRow, IonSelectOption } from "@ionic/vue";
import InputAmount from "@/components/input/InputAmount.vue";
import SelectBase from "@/components/selects/SelectBase.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import { usePersistentStore } from "@/stores/persistent";
import { computed } from "vue";

interface AddProductInterface {
    name: string;
    showCart?: boolean;
    showList?: boolean;
    isMultiple?: boolean;
    isMax?: boolean;
    amount?: number
    amountStep?: number;
    amountMax?: number;
    options?: any[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddProductInterface',
  props: {
    name: {},
    showCart: { type: Boolean },
    showList: { type: Boolean },
    isMultiple: { type: Boolean },
    isMax: { type: Boolean },
    amount: {},
    amountStep: {},
    amountMax: {},
    options: {}
  },
  emits: ['cart', 'list', 'update:amount'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const persistentStore = usePersistentStore()

const internalAmount = computed({
    get: () => {
        return props.amount
    },
    set: (value) => {
        emit('update:amount', value)
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.name)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(__props.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.options && Array.isArray(__props.options))
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "select", { options: __props.options }, () => [
                  _createVNode(SelectBase, {
                    class: "grey1-grey1-color grey4-grey4-background",
                    style: {"--original-background":"var(--ion-color-grey4)"},
                    placeholder: _ctx.$t('placeholder.selectSize')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('modal.selection')) + " ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (size) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: size,
                          value: size
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(size), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["placeholder"])
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    (__props.amount !== undefined)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 2,
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { size: "12" }, {
              default: _withCtx(() => [
                _createVNode(InputAmount, {
                  modelValue: internalAmount.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalAmount).value = $event)),
                  "amount-step": __props.amountStep
                }, null, 8, ["modelValue", "amount-step"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.isMultiple)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "coral-coral-color fs-small center-x" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('label.multipleAmount', { target: __props.amountStep ?? 1 })), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.isMax)
      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 4 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "coral-coral-color fs-small center-x" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('label.maxAmount', { target: __props.amountMax })), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ((__props.showCart || __props.showList))
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 5,
          class: "center-x"
        }, {
          default: _withCtx(() => [
            (__props.showCart)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 0,
                  size: "6",
                  class: _normalizeClass({'center-x': !__props.showList})
                }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonBase, {
                      color: _unref(ION_VARIANT).CORAL,
                      class: _normalizeClass(["fw-b wrap-button tt-none", {'mr-2': __props.showList}]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cart'))),
                      disabled: !__props.isMultiple || !__props.isMax || Boolean(_unref(persistentStore).offlineMode) || !__props.amount
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('modal.addCart')), 1)
                      ]),
                      _: 1
                    }, 8, ["color", "class", "disabled"])
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.showList)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 1,
                  size: "6",
                  class: _normalizeClass({
                'center-x': !__props.showCart,
                'ion-justify-content-end d-flex': __props.showCart
            })
                }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonBase, {
                      color: _unref(ION_VARIANT).CORAL,
                      fill: _unref(BUTTON_FILL).OUTLINE,
                      class: _normalizeClass(["fw-b wrap-button tt-none", {'ml-2': __props.showCart}]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('list'))),
                      disabled: !__props.isMultiple || !__props.isMax
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('modal.addList')), 1)
                      ]),
                      _: 1
                    }, 8, ["color", "fill", "class", "disabled"])
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})